"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class PageNotice {
    onCreate() {
        this.state = { dismissed: false };
    }
    onInput(input) {
        this.state = { dismissed: input.dismissed || false };
    }
    onDismiss() {
        this.state.dismissed = true;
        this.emit("dismiss");
    }
}
module.exports = PageNotice;
